var _path, _path2, _path3, _path4, _circle, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 82,
    viewBox: "0 0 80 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9586 12.5034H73.2113C75.9728 12.5034 78.2113 14.742 78.2113 17.5034V26.3016C78.2113 28.5646 76.6913 30.5455 74.5054 31.1312L41.7712 39.9023C40.9234 40.1294 40.0308 40.1294 39.183 39.9023L4.7059 30.6642C2.51999 30.0785 1 28.0976 1 25.8345V13.462C1 12.9326 1.42918 12.5034 1.9586 12.5034Z",
    stroke: "#132A3A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5293 12.5033V6C24.5293 3.23858 26.7679 1 29.5293 1H49.5075C52.2689 1 54.5075 3.23858 54.5075 6V12.5033",
    stroke: "#132A3A",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05444 32.6338V53.0804C6.05444 55.8418 8.29302 58.0804 11.0544 58.0804H17.2091",
    stroke: "#132A3A",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1567 32.6338V53.0804C73.1567 55.8418 70.9182 58.0804 68.1567 58.0804H62.0021",
    stroke: "#132A3A",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.6057,
    cy: 58.2549,
    r: 14.7734,
    stroke: "#45B14A",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4119 69.6709L63.8323 80.9999",
    stroke: "#45B14A",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindJob);
export default __webpack_public_path__ + "static/media/find-job.805086f18f8e943bfe34e5907b11521d.svg";
export { ForwardRef as ReactComponent };